<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName" >
    <div class="text-right leading-tight hidden sm:block">
      <vs-button color="danger" type="border" @click="logout">تسجيل خروج</vs-button>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
      isLoggedIn : function(){ return this.$store.getters.isLoggedIn}
  },
  methods: {
    logout: function ()  {
        this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
    },
  }
}
</script>
